// src/pages/LoginPage.tsx
import { SignIn } from "@clerk/clerk-react";

// Agrega estos console.log para verificar las variables de entorno
// console.log('VITE_CLERK_PUBLISHABLE_KEY:', import.meta.env.VITE_CLERK_PUBLISHABLE_KEY);
// console.log('VITE_CLERK_FRONTEND_API:', import.meta.env.VITE_CLERK_FRONTEND_API);
// console.log('VITE_API_URL:', import.meta.env.VITE_API_URL);

const LoginPage = () => {
  return (
    // w-full (no w-screen) + padding: evita desbordamiento horizontal en móvil
    <div className="w-full min-h-screen">
        <div className="mx-auto flex flex-col justify-center items-center text-left py-6 px-4 w-full max-w-md">
            <span className="p-4 text-lg font-bold">Login</span>
            <SignIn
                path="/login"
                routing="path"
                forceRedirectUrl="/"
            />
        </div>
    </div>
  );
};

export default LoginPage;
